export function checkTrackingManager(trackingManager: unknown): boolean {
    return typeof trackingManager === 'object' && !!trackingManager
}

export default function setTracking(
    // tslint:disable-next-line:no-any
    trackingManager: any,
    trackingEvent: string,
    data: object
): void {
    trackingManager.track(trackingEvent, data)
}
